import { render, staticRenderFns } from "./expertteam.vue?vue&type=template&id=2d793284&scoped=true&"
import script from "./expertteam.vue?vue&type=script&lang=js&"
export * from "./expertteam.vue?vue&type=script&lang=js&"
import style0 from "./expertteam.vue?vue&type=style&index=0&id=2d793284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d793284",
  null
  
)

export default component.exports